'use strict';

const kdContextError = require('./kd-context');

/**
 * Parse Error
 *
 * This error denotes a Parse Error, usually thrown when parser error occur
 *
 * If `context` is provided, it should contain the parse error details
 * and the context of the configuration (component, process, etc)
 *
 * @param {string} message - Error message
 * @param {Object} detail - Error detail message
 * @param {Object} context - Parse context data
 */
class ParseError extends kdContextError {
    constructor(message, detail, context) {
        super(message, detail, context);
        this.name = 'ParseError';
        this.status = '400';
    }
}

module.exports = ParseError;



/** WEBPACK FOOTER **
 ** ./src/common/error/parse.js
 **/